import ChevronRight from '@material-ui/icons/ChevronRight';
import cn from 'classnames';
import React, { FC } from 'react';
import Button from '../form/button';
import './styles.scss';

interface AlertProps {
	icon?: React.ReactNode;
	title?: string;
	description?: string;
	buttonText?: string;
	isActionButton?: boolean;
	onClick?: () => void;
	isWarning?: boolean;
	isInformation?: boolean;
	isError?: boolean;
	isRedirectionArrow?: boolean;
}

const AlertInfo: FC<AlertProps> = ({
	icon,
	title,
	description,
	buttonText,
	isActionButton,
	onClick,
	isWarning,
	isInformation,
	isError,
	isRedirectionArrow,
}) => {
	const alertClasses = cn('Alert', {
		'Alert--warning': isWarning,
		'Alert--information': isInformation,
		'Alert--error': isError,
		Alert__alignment: isRedirectionArrow,
	});

	const iconClasses = cn('Alert__icon', {
		'Alert__icon--warning': isWarning,
		'Alert__icon--information': isInformation,
		'Alert__icon--error': isError,
	});

	const renderActionButton = () => {
		if (!isActionButton) return null;
		return (
			<Button btnHeight="small" className="Alert__button" onClick={onClick}>
				{buttonText}
			</Button>
		);
	};

	return (
		<div className={alertClasses}>
			<div className="Alert__wrapper">
				<span className={iconClasses}>{icon}</span>
				<div className="Alert__content">
					<div className={cn({ Alert__infoMargin: isActionButton })}>
						<div className="Alert__infoBox">
							<span className="Alert__title">{title}</span>
							{isRedirectionArrow && <ChevronRight />}
						</div>
						<span className="Alert__description">{description}</span>
					</div>
				</div>
			</div>
			{renderActionButton()}
		</div>
	);
};

export default AlertInfo;
